// Styles
import '@boltenergy-be/design-system/foundations'
import 'styles/app.scss'

// Dependencies
import React, { PropsWithChildren } from 'react'
import { HelmetProvider } from '@dr.pogodin/react-helmet'
import { Provider } from 'react-redux'
import { store } from 'store'
import GeneralErrorHandler from 'components/general-error-handler/GeneralErrorHandler.tsx'
import { RouterProvider } from 'react-router/dom'
import { useStoreSelector } from 'hooks/store.ts'
import { selectStoreLoaded } from 'store/app/slice'
import { startUp } from 'utils/startUp.ts'
import { IS_PROD_OR_BETA } from 'constants/envs.ts'
import TagManager from '@sooro-io/react-gtm-module'
import { getCspNonce } from 'utils/csp.ts'
import router from 'router/routing.tsx'
import 'translations/i18next.ts'
import { PostHogProvider } from 'posthog-js/react'
import { ToastContainer } from '@boltenergy-be/design-system'
import posthog from 'posthog-js'

// Execute start up functions
startUp()

// Initialize GTM
TagManager.initialize({
  gtmId: IS_PROD_OR_BETA ? 'GTM-PLCVTWQ' : 'GTM-PJR5QWB',
  nonce: getCspNonce()
})

// Delays rendering until redux-remember has rehydrated the persisted state
const RehydrationGate = ({ children }: PropsWithChildren) => {
  const storeLoaded = useStoreSelector(selectStoreLoaded)
  return storeLoaded ? children : null
}

const App = () => (
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <RehydrationGate>
          <PostHogProvider client={posthog}>
            <GeneralErrorHandler>
              <RouterProvider router={router} />
              <ToastContainer className="toast" />
            </GeneralErrorHandler>
          </PostHogProvider>
        </RehydrationGate>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
)

export default App
